import { fetchRequestWithTypes } from './index.js';
import { PurchaseSource, TransferPathCapability } from 'stash/types/models/Transaction';

// Returns a user's buy sources.
// https://staging.stsh.io/documentation/1.0/buy-sources/index.html

export const GET_BUY_SOURCES_REQUEST = 'GET_BUY_SOURCES_REQUEST';
export const GET_BUY_SOURCES_SUCCESS = 'GET_BUY_SOURCES_SUCCESS';

export type GetBuySourcesSuccessAction = {
	type: typeof GET_BUY_SOURCES_SUCCESS;
	response: {
		sources: PurchaseSource[];
		capabilities?: TransferPathCapability[];
	};
};

export type GetBuySourcesResponse = {
	sources: PurchaseSource[];
	capabilities?: TransferPathCapability[];
};

export const GET_BUY_SOURCES_ERRORED = 'GET_BUY_SOURCES_ERRORED';

export const getBuySources = () => {
	return fetchRequestWithTypes({
		types: [GET_BUY_SOURCES_REQUEST, GET_BUY_SOURCES_SUCCESS, GET_BUY_SOURCES_ERRORED],
		request: {
			method: 'GET',
			path: '/apis/orders/v1/transactions/sources?transactionType=TRANSACTION_TYPE_BUY',
		},
	});
};


